exports.list = {
    path: '/jenis_hama',
    name: 'jenis_hama_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/jenis_hama/List.vue"),
}
exports.show = {
    path: '/jenis_hama/show/:id',
    name: 'jenis_hama_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/jenis_hama/Show.vue"),
}